import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button, IconGoogle } from "../../../components/atoms";
import { InputGroup } from "../../../components/molecules";
import { AuthContext } from "../../../contexts/Auth/AuthContext";
import { NotificationContext } from "../../../contexts/NotificationCTX/NotificationContext";
import { api } from "../../../helpers";

export function BaixaReserva() {
  const { applicationData } = useContext(AuthContext);
  const [campoObrigatorioReserva, setcampoObrigatorioReserva] =
    useState<boolean>(false);
  const {
    setType,
    setShow,
    setText: setTextAlert,
  } = useContext(NotificationContext);

  const [mensagem, setMensagem] = useState("");
  const [reserva, setReserva] = useState("");
  const [isBaixaButtonEnabled, setIsBaixaButtonEnabled] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const codigoReserva = searchParams.get("codigoReserva");
    if (codigoReserva) {
      setReserva(codigoReserva);
      setcampoObrigatorioReserva(false);
      baixar(true, codigoReserva);
    }
  }, [location]);

  useEffect(() => {
    setIsBaixaButtonEnabled(reserva !== "");
  }, [reserva]);

  function CompMensagem() {
    const linhas = mensagem.split("|");
    return (
      <div>
        {linhas.map((linha, index) =>
          linha.includes("Saida:") ? (
            <p key={index}>
              <strong>{linha}</strong>
            </p>
          ) : (
            <p key={index}>{linha}</p>
          )
        )}
      </div>
    );
  }

  const baixar = async (isQRCode: boolean, codigoReserva?: string) => {
    let usuario = applicationData.username;
    const response = await api.post(
      "/api/reserva/baixareserva",
      {
        reserva: isQRCode ? codigoReserva : reserva,
        usuario,
      },
      {
        headers: { Authorization: `Bearer ${applicationData.token}` },
      }
    );

    setMensagem(response.data);

    if (response.status === 200) {
      if (response.data.includes("Efetuada com sucesso")) {
        setType("success");
      } else {
        setType("danger");
      }
      setTextAlert(response.data.split("|")[0]);
      setReserva("");
      setShow(true);

      // Automatically hide the message after 3 seconds
      setTimeout(() => {
        setShow(false);
      }, 3000);
    }
  };

  return (
    <div>
      <h2>Baixa das Reservas</h2>
      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-2"
            label="Reserva a Ser Baixada"
            messageError={campoObrigatorioReserva ? "Campo obrigatório!" : ""}
            id="duracao"
            type="string"
            value={reserva}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "") {
                setReserva(e.target.value);
                setcampoObrigatorioReserva(false);
              }
              if (e.target.value === "") setcampoObrigatorioReserva(true);
            }}
          />
        </div>

        <div className="row mt-3"></div>

        <div className="col-sm-12 col-lg-3">
          <Button
            className="col-sm-12 col-lg-4"
            appearance="success"
            onClick={() => {
              baixar(false);
            }}
            disabled={!isBaixaButtonEnabled}
          >
            Efetuar Baixa<IconGoogle>manage_search</IconGoogle>
          </Button>
        </div>
      </div>
      <div className="row mt-3">
        <CompMensagem />
      </div>
    </div>
  );
}
